import auth from "@/api/model/auth"
import system from "@/api/model/system"
import tools from "@/api/model/tools"
import institution from "@/api/model/institution"
import maintain from "@/api/model/maintain"
import machine from "@/api/model/machine"
import trade from "@/api/model/trade"
import developer from "@/api/model/developer"
import dashboard from "@/api/model/dashboard"
import wallet from "@/api/model/wallet"
import kb from "@/api/model/kb"

export default {
	auth,
	system,
	tools,
	institution,
	maintain,
	machine,
	trade,
	developer,
	dashboard,
	wallet,
	kb
}
